<template>
    <div class="no_dataset_" id="map-no-data">
        <img src="../../../assets/images/nodata_s.svg">
    </div>
</template>
<script>
export default {
    name: 'ComponentNoDataPage',
}
</script>